module.exports = __webpack_public_path__ + "static/desktop/img/diarybook-4-thumb.3fa25e15.png";